import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FieldLabel, ProviderDot } from "./GraphicsHelpers";
import { PROVIDER_LABELS, PROVIDER_COLORS } from "@/lib/graphicsConstants";

export function ModelSelector({ modelRegistry, selectedProvider, selectedModel, currentModelLabel, onModelSelect }) {
  return (
    <div>
      <FieldLabel required>AI Image Model</FieldLabel>
      <Select value={`${selectedProvider}:${selectedModel}`} onValueChange={onModelSelect}>
        <SelectTrigger
          className="bg-[var(--bg-card)] border-[var(--border-strong)] text-sm h-11"
          data-testid="gfx-model-select"
        >
          <SelectValue>
            <span className="flex items-center gap-2">
              <ProviderDot provider={selectedProvider} />
              <span className="font-medium">{PROVIDER_LABELS[selectedProvider]}</span>
              <span className="text-[var(--text-muted)]">/</span>
              <span>{currentModelLabel}</span>
            </span>
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="max-h-[400px]">
          {Object.entries(modelRegistry).map(([providerKey, models]) => (
            <SelectGroup key={providerKey}>
              <SelectLabel className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider py-2">
                <ProviderDot provider={providerKey} />
                <span className={PROVIDER_COLORS[providerKey]}>{PROVIDER_LABELS[providerKey]}</span>
              </SelectLabel>
              {Object.entries(models).map(([modelKey, info]) => (
                <SelectItem key={`${providerKey}:${modelKey}`} value={`${providerKey}:${modelKey}`}>
                  <div className="flex flex-col py-0.5">
                    <span className="font-medium text-[var(--text-primary)]">{info.label}</span>
                    <span className="text-[10px] text-[var(--text-muted)] leading-tight">{info.use_case}</span>
                  </div>
                </SelectItem>
              ))}
            </SelectGroup>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
